import React from 'react'

import {
    Grid,
    Typography,
    Divider
  } from "@material-ui/core";
import moment from 'moment';
import { MENU_INFORMACION_EXPEDIENTES, TIPO_COMPROBANTE_DOCUMENTO } from '../../../utils/constants';

function dateFormat(date){
    return moment(date).format("DD/MM/YYYY")
}

function checkEmpty(value){
    if(value === "" || value === null)
        return 'No se ingreso ningún valor'
    else
        return value
}

function fillNum(num, type){
    if(type === "sucursal")
        return num.toString().padStart((5), '0');
    else if(type === "factura")
        return num.toString().padStart((8), '0');
}

export const InformacionComprobante = (props) => {
    const { tab, classes, expediente, tipoComprobanteDocumento }= props;

    return (
        <Grid 
            container
            spacing={1}
            justify="center"
        >
            <Grid item xs={5} className={classes.column}>
                <Typography variant="subtitle1">
                    Fecha Recepción 
                </Typography>
                <Typography variant="button">
                    {dateFormat(expediente.fechaRecepcion)}
                </Typography>
            </Grid>
            <Grid item xs={5} className={classes.column}>
                <Typography variant="subtitle1">
                    Procedencia 
                </Typography>
                <Typography variant="button">
                    {expediente.descripcionProcedencia}
                </Typography>
            </Grid>
            <Grid item xs={12}><Divider /></Grid>
            {MENU_INFORMACION_EXPEDIENTES.DATOS_COMPROBANTE_DOCUMENTO === tab ?
                <>
                    <Grid item xs={12}  className={classes.center}>
                        <Typography variant="h6" style={{margin: "5px"}}>
                            Comprobante
                        </Typography>
                    </Grid>
                    <Grid item xs={4} className={classes.column}>
                        {TIPO_COMPROBANTE_DOCUMENTO.DOCUMENTACION === tipoComprobanteDocumento ? (
                            <>
                                <Typography variant="subtitle1">
                                    Fecha Carta 
                                </Typography>
                                <Typography variant="button">
                                    {dateFormat(expediente.fechaCarta)}
                                </Typography>
                            </>
                        ) : (
                            <>
                                <Typography variant="subtitle1">
                                    Cuit
                                </Typography>
                                <Typography variant="button">
                                    {checkEmpty(expediente.cuit)}
                                </Typography>
                            </>
                        )}
                    </Grid>
                    <Grid item xs={4} className={classes.column}>
                        {TIPO_COMPROBANTE_DOCUMENTO.DOCUMENTACION === tipoComprobanteDocumento ? (
                            <>
                                <Typography variant="subtitle1">
                                    Entregado Por
                                </Typography>
                                <Typography variant="button">
                                    {expediente?.entregadoPor}
                                </Typography>
                            </>
                        ) : (
                            <>
                                <Typography variant="subtitle1">
                                    CBU Embargo 
                                </Typography>
                                <Typography variant="button">
                                    {checkEmpty(expediente.cbuEmbargo)}
                                </Typography>
                            </>
                        )}
                    </Grid>
                    <Grid item xs={4} className={classes.column}>
                        {TIPO_COMPROBANTE_DOCUMENTO.DOCUMENTACION === tipoComprobanteDocumento ? (
                            <>
                                <Typography variant="subtitle1">
                                    Folios
                                </Typography>
                                <Typography variant="button">
                                    {checkEmpty(expediente?.folios)}
                                </Typography>
                            </>
                        ) : (
                            <>
                                <Typography variant="subtitle1">
                                    Importe
                                </Typography>
                                <Typography variant="button">
                                    $ {checkEmpty(parseFloat(expediente.importe).toFixed(2))}
                                </Typography>
                            </>
                        )}
                    </Grid>
                    <Grid item xs={12} style={{margin: "5px"}} className={classes.column}>
                        {TIPO_COMPROBANTE_DOCUMENTO.DOCUMENTACION === tipoComprobanteDocumento ? (
                            <>
                                <Typography variant="subtitle1">
                                    Carátula
                                </Typography>
                                <Typography className={classes.textObservaciones}>
                                    {checkEmpty(expediente?.caratula)}
                                </Typography>
                            </>
                        ) : (
                            <>
                                <Typography variant="subtitle1">
                                    Auto Documento 
                                </Typography>
                                <Typography className={classes.textObservaciones}>
                                    {checkEmpty(expediente.autos)}
                                </Typography>
                            </>
                        )}
                    </Grid>
                </>
                :
                <>
                    <Grid item xs={12}  className={classes.center}>
                        <Typography variant="h6" style={{margin: "10px"}}>
                            Comprobante
                        </Typography>
                    </Grid>
                    <Grid item xs={3} className={classes.column}>
                        <Typography variant="subtitle1">
                            Tipo Comprobante
                        </Typography>
                        <Typography variant="button">
                            {expediente?.descripcionTipoComprobante}
                        </Typography>
                    </Grid>
                    <Grid item xs={3} className={classes.column}>
                        <Typography variant="subtitle1">
                            N° Comprobante
                        </Typography>
                        <Typography variant="button">
                            {expediente?.nroSucursal && expediente?.nroFactura 
                                ? `${expediente?.descripcionTipoFactura} / ${fillNum(expediente?.nroSucursal, "sucursal")}-${fillNum(expediente?.nroFactura, "factura")}`
                                : "No posee N° Comprobante"
                            }
                        </Typography>
                    </Grid>
                    <Grid item xs={3} className={classes.column}>
                        <Typography variant="subtitle1">
                            Total Comprobante
                        </Typography>
                        <Typography variant="button">
                            $ {parseFloat(expediente?.totalComprobante).toFixed(2)}
                        </Typography>
                    </Grid>
                    <Grid item xs={3} className={classes.column}>
                        <Typography variant="subtitle1">
                            CAI/CAE
                        </Typography>
                        <Typography variant="button">
                            {expediente?.caiCae}
                        </Typography>
                    </Grid>
                    {expediente?.idPresupuesto &&
                        <>
                            <Grid item xs={4} className={classes.column}>
                                <Typography variant="subtitle1">
                                    N° Presupuesto
                                </Typography>
                                <Typography variant="button">
                                    {expediente?.idPresupuesto}
                                </Typography>
                            </Grid>
                            <Grid item xs={4} className={classes.column}>
                                <Typography variant="subtitle1">
                                    Valor Presupuesto
                                </Typography>
                                <Typography variant="button">
                                    {expediente?.valorPresupuesto}
                                </Typography>
                            </Grid>
                            <Grid item xs={4} className={classes.column}>
                                <Typography variant="subtitle1">
                                    N° Afiliado
                                </Typography>
                                <Typography variant="button">
                                    {expediente?.idAfiliado}
                                </Typography>
                            </Grid>
                        </>
                    }
                    <Grid item xs={5} className={classes.column}  style={{margin: "10px"}}>
                        <Typography variant="subtitle1">
                            Fecha Comprobante 
                        </Typography>
                        <Typography variant="button">
                            {dateFormat(expediente.fechaInicioVigencia)}
                        </Typography>
                    </Grid>
                    <Grid item xs={5} className={classes.column}  style={{margin: "10px"}}>
                        <Typography variant="subtitle1">
                            Fecha Vencimiento 
                        </Typography>
                        <Typography variant="button">
                            {dateFormat(expediente.fechaFinVigencia)}
                        </Typography>
                    </Grid>
                </>
            }
            <Grid item xs={12} style={{margin: "5px"}} className={classes.column}>
                <Typography variant="subtitle1">
                    Observaciones
                </Typography>
                <Typography className={classes.textObservaciones}>
                    {checkEmpty(expediente?.observaciones)}
                </Typography>
            </Grid>
        </Grid>
    )
}
